<div class="close-valuation-event-info" *ngIf="showTitleInfo">
  <h2>{{'raci.closeValuationEvent.title' | translate | uppercase}}</h2>
</div>
<div class="close-valuation-event-info" *ngIf="!hasReports">
  <span>{{'raci.closeValuationEvent.missingReports' | translate}}</span>
</div>
<div class="close-valuation-event-info" *ngIf="hasReports">
  <div class="close-val-event-important-pane">
    <span class="close-val-event-important-text">{{'raci.closeValuationEvent.closeValuationEventImportant' | translate}} </span>
    <span>{{'raci.closeValuationEvent.closeValuationEventImportantDescription' | translate}}</span>
  </div>
  <div class="options-container">
    <div class="option-container">
      <input class="custom-checbox" type="radio" [disabled]="selectedTask?.taskActionStage != ActionStageEnum.Waiting" [(ngModel)]="optionSelected" (click)="hideCloseValuationEventDialog($event)" [value]="1" />
      <label class="option-text" for="radio">{{'raci.closeValuationEvent.closeValuationEventFirstOption' | translate}}</label>
      <div class="option-description" *ngIf="optionSelected == '1'">
        <p>{{'raci.closeValuationEvent.closeFirstOptionDescription' | translate}}</p>
        <button kendoButton class="continue-btn" (click)="continue(1)">{{'raci.closeValuationEvent.continue' | translate}}</button>
      </div>
    </div>
    <div class="option-container">
      <input class="custom-checbox" type="radio" [disabled]="selectedTask?.taskActionStage != ActionStageEnum.Waiting" [(ngModel)]="optionSelected" (click)="selectCloseValuationEventOption($event)" [value]="2"/>
      <label class="option-text" for="radio">{{'raci.closeValuationEvent.closeValuationEventSecondOption' | translate}}</label>
      <div class="option-description" *ngIf="optionSelected == '2'">
        <p>{{'raci.closeValuationEvent.closeSecondOptionDescription' | translate}}</p>
        <h4>{{'raci.closeValuationEvent.createNewBasicInfo' | translate | uppercase}}</h4>
        <div class="create-basic-info-container">
          <div class="input-container">
            <p>{{'raci.closeValuationEvent.createNewValuationName' | translate | uppercase}}</p>
            <input class="name-input" [(ngModel)]="valuationName">
          </div>
          <div class="input-container">
            <p>{{'raci.closeValuationEvent.createNewValuationDate' | translate | uppercase}}</p>
            <input type="date" class="date-input" [(ngModel)]="valuationDate">
          </div>
        </div>

        <h4>{{'raci.closeValuationEvent.createNewDuplicateData' | translate}}</h4>
        <div class="create-duplicate-data">
          <label class="copy-option-label">
            <input type="checkbox" [(ngModel)]="copyProperties" class="copy-input">{{'raci.closeValuationEvent.createNewCopyPropertiesLabel' | translate}}
          </label>
          <label class="copy-option-label">
            <input type="checkbox" [(ngModel)]="copyFxTables" class="copy-input">{{'raci.closeValuationEvent.createNewCopyFxTablesLabel' | translate}}
          </label>
        </div>
        <button kendoButton class="continue-btn" (click)="continue(2)">{{'raci.closeValuationEvent.continue' | translate}}</button>
      </div>
    </div>
    <div class="option-container">
      <input class="custom-checbox" type="radio" [disabled]="selectedTask?.taskActionStage != ActionStageEnum.Waiting" [(ngModel)]="optionSelected" (click)="hideCloseValuationEventDialog($event)" [value]="3" />
      <label class="option-text" for="radio">{{'raci.closeValuationEvent.closeValuationEventThirdOption' | translate}}</label>
      <div class="option-description" *ngIf="optionSelected == '3'">
        <p>{{'raci.closeValuationEvent.closeThirdOptionDescription' | translate}}</p>
        <p>{{'raci.closeValuationEvent.closeProjectAndValuationEventMessage' | translate}}</p>
        <ul>
          <li class="open-valuation-events-list" *ngFor="let valEvent of selectedTask.openValuationEvents">{{valEvent.valuationPortfolioName}}</li>
        </ul>
        <button kendoButton class="continue-btn" [disabled]="selectedTask?.taskActionStage != ActionStageEnum.Waiting" (click)="continue(3)">{{'raci.closeValuationEvent.continue' | translate}}</button>
      </div>
    </div>
  </div>
</div>
